import gsap from 'gsap';
import splitText from './splitText';

const revealPost = (container) => {

    const postPils = container.querySelector('.bg-post-pils');

    const tl = gsap.timeline()

    tl
    // .from('.bg-main', { autoAlpha:0, duration: .1, ease: 'none' })
    .from( postPils, {autoAlpha:0, delay:.6, duration:.3} )
    // .add ( splitText('.bg-post__title') )
    .fromTo( '.bg-post__title', {autoAlpha:0, yPercent:30},{ autoAlpha:1, yPercent:0, duration: .4, ease: "power2.out" } )
    .fromTo( '.bg-post__description', {autoAlpha:0, yPercent:101},{autoAlpha:1, yPercent:0 }, '>-.2' )

        // tl.timeScale(0.2)

    return tl
}

export default revealPost;